import { CoreMenu } from '@core/types';

//? DOC: http://localhost:7777/demo/vuexy-angular-admin-dashboard-template/documentation/guide/development/navigation-menus.html#interface

export const menu: CoreMenu[] = [
  // Apps & Pages
  {
    id: 'Assets',
    type: 'section',
    title: 'Assets',
    translate: 'MENU.APPS.SECTION',
    icon: 'package',
    children: [
      {
        id: 'myAccount',
        title: 'My Account',
        translate: 'MENU.APPS.MYACCOUNT',
        type: 'item',
        icon: 'user',
        url: 'actor'
      },
      {
        id: 'Assets',
        title: 'Assets',
        translate: 'MENU.APPS.ASSETS',
        type: 'item',
        icon: 'globe',
        url: 'tokens'
      },
      {
        id: 'Transactions',
        title: 'Transactions',
        translate: 'MENU.APPS.TRANSACTIONS',
        type: 'item',
        icon: 'activity',
        url: 'transaction'
      }
    ]
  },
];
